const kmToMiles = (distance) => distance * 0.621371;
const kmToNauticalMiles = (distance) => distance * 0.539957;

export { kmToMiles, kmToNauticalMiles };
